import actions from "./actions";

const initState = {
    inventoryTransferMessage: null,
    inventoryTransferLoading: false,
    inventoryTransferError: null,
    inventoryTransferFResult: [],

};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.INVENTORY_TRANSFER:
            return {
                ...state,
                inventoryTransferMessage: null,
                inventoryTransferLoading: true,
                inventoryTransferError: null,
                inventoryTransferFResult: []
            };
        case actions.INVENTORY_TRANSFER_SUCCESS:
            return {
                ...state,
                inventoryTransferLoading: false,
                inventoryTransferMessage: action.message,
                inventoryTransferError: null,
            };
        case actions.INVENTORY_TRANSFER_FAILED:
            return {
                ...state,
                inventoryTransferLoading: false,
                inventoryTransferError: action.payload.error,
                inventoryTransferFResult: action.payload.fResult
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                inventoryTransferMessage: null,
                inventoryTransferError: null,
                inventoryTransferFResult: []
            };


        default:
            return state;
    }
}
